import type { EventMarketType } from "app/types/eventType";
import type { Element } from "React";
import { Component } from "react";
import "./BinaryMarketTypeSubheading.scss";
type Props = {
  markets: EventMarketType[];
};

class BinaryMarketTypeSubheading extends Component<Props> {
  getMarket = (markets: EventMarketType[]) => {
    return markets.find(market => {
      return market.runners?.length > 1;
    });
  };
  render(): Element<"div"> {
    const { markets } = this.props;
    const market = this.getMarket(markets);
    return (
      <div className={"subheading binary"}>
        {market?.runners.map(runner => {
          return <span key={"runner" + runner.id}>{runner.name}</span>;
        })}
      </div>
    );
  }
}

export default BinaryMarketTypeSubheading;
